import React from 'react'
import { Input, BaseButton } from 'iebt-zing-storybook'
import { trans } from 'sharedKernel/i18n'
import * as S from './style'

interface InviteFormProps {
  memberName: string
  emailValue: string
  positionValue: string
  onChangeName: (value: string) => void
  onChangeEmail: (value: string) => void
  onChangePosition: (value: string) => void
  onAdd: () => void
}

export const InviteForm = ({
  memberName,
  emailValue,
  positionValue,
  onChangeName,
  onChangeEmail,
  onChangePosition,
  onAdd
}: InviteFormProps): JSX.Element => {
  const disabled = !memberName.trim() || !emailValue.trim() || !positionValue.trim()

  return (
    <S.AddMemberWrapper>
      <S.MemberButtonWrapper>
        <div className="member-input">
          <Input
            id="memberName"
            isRequired={true}
            value={memberName}
            label={trans('Nome do membro')}
            onChange={(event) => onChangeName(event.target.value)}
          />
        </div>
        <div className="member-input">
          <Input
            id="memberEmail"
            isRequired={true}
            value={emailValue}
            label={trans('E-mail do membro')}
            onChange={(event) => onChangeEmail(event.target.value.split(' ').join(''))}
          />
        </div>
        <div className="member-input">
          <Input
            id="memberPosition"
            isRequired={true}
            value={positionValue}
            label={trans('Cargo do membro')}
            onChange={(event) => onChangePosition(event.target.value)}
          />
        </div>
        <div className="add-button mb-3">
          <BaseButton
            disabled={disabled}
            btnContent={trans('Adicionar')}
            variant="primary"
            size="medium"
            onClick={onAdd}
          />
        </div>
      </S.MemberButtonWrapper>
    </S.AddMemberWrapper>
  )
}